module.exports = __webpack_public_path__ + "img/32.d37aca60.jpg";